<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-14 17:55:36
 * @LastEditTime: 2021-06-18 11:38:29
 * @LastEditors: JDY
-->
<template>
  <a-spin :spinning="loading">
    <a-form :form="form">
      <a-form-item label="文件" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <file-upload
          file="import"
          url="/upload/temporary/import"
          name="file"
          v-decorator="['files', { rules: [{ required: true, min: 5, message: '请上传文件' }] }]"
        />
      </a-form-item>
      <a-form-item label="考试模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择考试模式"
          style="width: 100%"
          name="mode_id"
          optionFilterProp="children"
          allow-clear
          v-decorator="['mode_id', { rules: [{ required: true, message: '请选择考试模式' }] }]"
        >
          <a-select-option v-for="mode in modesList" :key="mode.id">
            {{ mode.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="选择证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择证书"
          style="width: 100%"
          name="crt_id"
          optionFilterProp="children"
          allow-clear
          v-decorator="['crt_id', { rules: [{ required: true, message: '请选择证书' }] }]"
        >
          <a-select-option v-for="crt in crtsList" :key="crt.id">{{ crt.title }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="到期时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          name="expire_date"
          showTime
          style="width: 100%"
          placeholder="请选择到期时间"
          format="YYYY-MM-DD HH:mm:ss"
          v-decorator="['expire_date', { rules: [{ required: true, message: '请选择到期时间' }] }]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { FileUpload } from '@/components'
import { select } from '@/mixins' // 引入

import { requestPost } from '@/api/api'

// 表单字段
const fields = ['description', 'id']
const apiList = {
    create: '/certificates/codes/create',
    crtsSelect: '/certificates/select', // 获取证书下拉
    modesSelect: '/certificates/modes/select' // 获取模式下拉
}

export default {
    props: {
        loading: {
            type: Boolean,
            default: () => false
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    components: {
        FileUpload
    },
    mixins: [select], // 使用mixins
    data () {
        return {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            modesLoad: false,
            modesList: [], // 分类下拉数据
            crtsLoad: false,
            crtsList: [],
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.crtsSelect,
            type: 'crtsList',
            load: 'crtsLoad'
        })
        this.getSelectLists({
            url: apiList.modesSelect,
            type: 'modesList',
            load: 'modesLoad'
        })
    },
    created () {
        // 防止表单未注册
        fields.forEach(v => this.form.getFieldDecorator(v))
        // 当 model 发生改变时，为表单设置值
        this.$watch('model', () => {
            this.model && this.form.setFieldsValue(pick(this.model, fields))
        })
    },
    methods: {
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.id = this.$props.ids
                        requestPost(apiList.create, values)
                            .then(res => {
                                this.$notification.success(res.msg)
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
